import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { api } from "../lib/api";
import { fmtDate } from "../lib/format";
import { toast } from "sonner";

export default function Handoffs() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/handoffs").then(r => setRows(r.data)).catch(() => toast.error("Failed to load")); }, []);
  return (
    <AppShell header={<div className="border-b border-zinc-800 px-6 py-4"><div className="overline">Owner Handoffs</div><h1 className="text-lg font-semibold">HOT DEAL notifications sent to your private inbox</h1></div>}>
      <div className="p-6">
        {rows.length === 0 ? (
          <div className="border border-dashed border-zinc-800 p-12 text-center rounded-sm">
            <div className="overline mb-2">No handoffs yet</div>
            <div className="text-sm text-zinc-500">When a seller replies "Yes," the thread will be forwarded here.</div>
          </div>
        ) : (
          <ul className="space-y-3" data-testid="handoffs-list">
            {rows.map(h => (
              <li key={h.id} className="border border-emerald-500/30 bg-emerald-500/5 p-4 rounded-sm">
                <div className="flex items-center justify-between">
                  <div className="text-sm font-semibold">{h.subject}</div>
                  <div className="text-[10px] mono text-zinc-500">{fmtDate(h.created_at)}</div>
                </div>
                <div className="text-xs text-zinc-400 mono mt-1 flex flex-wrap gap-x-4 gap-y-1">
                  <span>email → {h.to}</span>
                  {h.sms_to && <span>sms → {h.sms_to}</span>}
                  {h.sms_status && (
                    <span className={h.sms_status === "sent" ? "text-emerald-400" : "text-amber-400"}>
                      · {h.sms_status}
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </AppShell>
  );
}
